import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { APPEARANCE } from "@circle-react/providers";
import type { DropdownButton } from "./types";
import { adminIconsV3 } from "./useAdminIcons";

interface GetToggleThemeProps {
  currentAppearance: "light" | "dark";
  showToggleTheme: boolean;
  toggleAppearance?: () => void;
}
export const useGetToggleTheme = ({
  showToggleTheme,
  currentAppearance,
  toggleAppearance = noop,
}: GetToggleThemeProps): DropdownButton[] => {
  const { toggleThemeLightIcon, toggleThemeDarkIcon } = adminIconsV3;

  if (!showToggleTheme) return [];

  return [
    {
      value: currentAppearance,
      label:
        currentAppearance === APPEARANCE.LIGHT
          ? t("sidebar_switch_to_dark_mode")
          : t("sidebar_switch_to_light_mode"),
      onClick: toggleAppearance,
      icon:
        currentAppearance === APPEARANCE.LIGHT
          ? toggleThemeLightIcon
          : toggleThemeDarkIcon,
      iconSize: 20,
    },
  ];
};
